import React, { useState, useContext, useEffect } from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import AppContext from "../context/AppContext";
import { useNavigate } from 'react-router-dom';
import CTFLIXLogo from "../assets/svg/ctflix-logo.svg";
import EllipseOrange from "../assets/svg/ellipse/ellipse-orange.svg"
import Basic from "../assets/img/basic.jpg";
import Intermediate from "../assets/img/intermediate.jpg";
import Advanced from "../assets/img/advance.jpg";
import LanguageAndNotificacions from "../components/LanguageAndNotificacions";


const CTFLIX = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [currentVideo, setCurrentVideo] = useState(0); // Estado para el video actual
    const { loading, updateLoading, play, savePlay } = useContext(AppContext);
    const [basicList, setBasicList] = useState([]);
    const [intermediateList, setIntermediateList] = useState([]);
    const [advancedList, setAdvancedList] = useState([]);
    const [packageUser, setPackageuser] = useState(0);
    const [selectedLanguage, setSelectedLanguage] = useState(localStorage.getItem("lng") === "Spanish" ? "es" : "en");
    const [selectedModule, setSelectedModule] = useState('all');
    const [selectedType, setSelectedType] = useState('all');


    // Filtro dinámico para el lenguaje
    const handleLanguageChange = (e) => {
        setSelectedLanguage(e.target.value);
    };

    // Filtro dinámico para el módulo
    const handleModuleChange = (e) => {
        setSelectedModule(e.target.value);
    };

    // Filtro dinámico para el tipo
    const handleTypeChange = (e) => {
        setSelectedType(e.target.value);
    };

    useEffect(() => {
        getUsersData();
        getAllPlay();
    }, []);

    const getUsersData = () => {
        updateLoading(true);
        fetch(`${process.env.REACT_APP_BACKEND}/users`, {
            method: "GET",
            headers: {
                Authorization: `${localStorage.getItem("token")}`,
            },
        })
            .then((response) => response.json())
            .then((response) => {
                const data = response?.data;
                setPackageuser(data?.package)
                updateLoading(false);
            })
            .catch((error) => {
                console.log(error);
                updateLoading(false);
            });
    }

    const getAllPlay = () => {
        updateLoading(true);
        fetch(`${process.env.REACT_APP_BACKEND}/ctflix-list`, {
            method: "GET",
            headers: {
                Authorization: `${localStorage.getItem("token")}`,
            },
        })
            .then((response) => response.json())
            .then((response) => {
                setBasicList(response?.basic)
                setIntermediateList(response?.intermediate)
                setAdvancedList(response?.advanced)
                updateLoading(false);
            })
            .catch((error) => {
                console.log(error);
                updateLoading(false);
            });
    }


    const gotoPlay = (item) => {
        savePlay(item)
        navigate("/play");
    }

    const filterList = (list) => {
        return list.filter(item => {
            const languageCondition = selectedLanguage === 'all' || item.language === selectedLanguage;
            const moduleCondition = selectedModule === 'all' || item.module === selectedModule;
            const typeCondition = selectedType === 'all' || item.type === selectedType;
            return languageCondition && moduleCondition && typeCondition;
        });
    };

    // Filtro de las listas con base en los filtros
    const filteredBasicList = filterList(basicList);
    const filteredIntermediateList = filterList(intermediateList);
    const filteredAdvancedList = filterList(advancedList);



    const moduleDescription = (item) => {
        if (item === "0") {
            return t("_CTFLIX._MODULE0")
        } else if (item === "1") {
            return t("_CTFLIX._MODULE1")
        } else if (item === "2") {
            return t("_CTFLIX._MODULE2")
        } else if (item === "3") {
            return t("_CTFLIX._MODULE3")
        } else if (item === "4") {
            return t("_CTFLIX._MODULE4")
        } else if (item === "5") {
            return t("_CTFLIX._MODULE5")
        } else if (item === "6") {
            return t("_CTFLIX._MODULE6")
        } else if (item === "7") {
            return t("_CTFLIX._MODULE7")
        } else if (item === "8") {
            return t("_CTFLIX._MODULE8")
        } else if (item === "9") {
            return t("_CTFLIX._MODULE9")
        } else if (item === "10") {
            return t("_CTFLIX._MODULE10")
        } else if (item === "11") {
            return t("_CTFLIX._MODULE11")
        } else if (item === "12") {
            return t("_CTFLIX._MODULE12")
        } else if (item === "13") {
            return t("_CTFLIX._MODULE13")
        } else if (item === "14") {
            return t("_CTFLIX._MODULE14")
        } else if (item === "15") {
            return t("_CTFLIX._MODULE15")
        }
        return t("_CTFLIX._ALLLANGUAGE");  // En caso de que no se encuentre el módulo
    };


    const goToPackages = () => {
        navigate("/packages");
    }


    return (
        <>
            <div className="flex flex-col lg:flex-row lg:justify-between w-3/4 lg:w-full gap-3">
                <h1 className="text-white text-3xl"></h1>
                <LanguageAndNotificacions />
            </div>
            <div className="bg-black/90 p-4 rounded-lg">
                <div className="flex justify-center">
                    <img src={EllipseOrange} alt="Ellipse Orange" className="z-1 absolute w-4/12 -top-40 opacity-50" />
                    <img src={CTFLIXLogo} alt="CTFLIX" />

                </div>
                <div className="max-w-7xl mx-auto p-6 text-white">

                    <div className="flex lg:flex-row flex-col lg:space-x-4 mb-4 gap-2">
                        <select
                            onChange={handleLanguageChange}
                            value={selectedLanguage}
                            className="bg-gray-800 text-white rounded-lg p-2 z-20"
                        >
                            <option value="all">{t("_CTFLIX._ALLLANGUAGE")}</option>
                            <option value="es">Español</option>
                            <option value="en">Inglés</option>
                            <option value="it">Italiano</option>
                        </select>

                        <select
                            onChange={handleTypeChange}
                            value={selectedType}
                            className="bg-gray-800 text-white rounded-lg p-2 z-20"
                        >
                            <option value="all">{t("_CTFLIX._ALLTYPES")}</option>
                            <option value="basic">{t("_CTFLIX._BASIC")}</option>
                            <option value="intermediate">{t("_CTFLIX._INTERMEDIATE")}</option>
                            <option value="advanced">{t("_CTFLIX._ADVANCED")}</option>
                        </select>
                        <select
                            onChange={handleModuleChange}
                            value={selectedModule}
                            className="bg-gray-800 text-white rounded-lg p-2 z-20"
                        >
                            <option value="all">{t("_CTFLIX._ALLLMODULES")}</option>
                            <option value="0">{moduleDescription("0")}</option>
                            <option value="1">{moduleDescription("1")}</option>
                            <option value="2">{moduleDescription("2")}</option>
                            <option value="3">{moduleDescription("3")}</option>
                            <option value="4">{moduleDescription("4")}</option>
                            <option value="5">{moduleDescription("5")}</option>
                            <option value="6">{moduleDescription("6")}</option>
                            <option value="7">{moduleDescription("7")}</option>
                            <option value="8">{moduleDescription("8")}</option>
                            <option value="9">{moduleDescription("9")}</option>
                            <option value="10">{moduleDescription("10")}</option>
                            <option value="11">{moduleDescription("11")}</option>
                            <option value="12">{moduleDescription("12")}</option>
                            <option value="13">{moduleDescription("13")}</option>
                            <option value="14">{moduleDescription("14")}</option>
                            <option value="15">{moduleDescription("15")}</option>
                        </select>

                    </div>
                    <>
                        <h2 className="text-3xl font-semibold mb-6">{t("_CTFLIX._BASIC")}</h2>
                        {packageUser >= 1 ? (
                            <>
                                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                                    {filteredBasicList.map(item => (
                                        <div onClick={() => gotoPlay(item)} key={item.id} className="max-w-96 h-50 bg-gray-800 rounded-lg shadow-lg cursor-pointer opacity-50 hover:opacity-100 ">
                                            <img className="w-full h-40 object-cover" src={item?.image ? item?.image : Basic} alt="Curso Basic" />
                                            <div className="p-4">
                                                <h3 className="text-md font-semibold text-white min-h-16">{item.name}</h3>
                                                <div className="mt-2 flex justify-between items-center">
                                                    <span className="text-sm text-gray-400">{moduleDescription(item?.module)}</span>
                                                    <span className="text-sm text-green-500">
                                                        {(item.currentTime && item.duration) ? Math.round((item.currentTime / item.duration) * 100) : 0}%
                                                    </span>
                                                </div>
                                                <div className="mt-2 h-2 bg-gray-600 rounded-full">
                                                    <div className="h-full shim-green" style={{ width: `${(item.currentTime && item.duration) ? Math.round((item.currentTime / item.duration) * 100) : 0}%`, }}></div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </>
                        ) : (
                            <div className="flex flex-col items-center justify-center w-full h-64 bg-gray-800 rounded-lg">
                                <p className="text-white text-lg mb-4 p-4 text-center">{t("_CTFLIX._REQUIREDBASIC")}</p>
                                <button className="text-md w-auto border-2 p-4 px-6 cursor-pointer rounded-xl bg-rose-500 text-white" onClick={() => goToPackages()}>{t("_DASHBOARD._UPGRADE")} </button>
                            </div>
                        )}
                    </>
                    <h2 className="text-3xl font-semibold mt-12 mb-6">{t("_CTFLIX._INTERMEDIATE")}</h2>
                    {packageUser >= 2 ? (
                        <>
                            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                                {filteredIntermediateList.map(item => (
                                    <div onClick={() => gotoPlay(item)} key={item.id} className="max-w-96 h-50 bg-gray-800 rounded-lg shadow-lg cursor-pointer opacity-50 hover:opacity-100 ">
                                        <img className="w-full h-40 object-cover" src={item?.image ? item?.image : Intermediate} alt="Curso INTERMEDIATE" />
                                        <div className="p-4">
                                            <h3 className="text-md font-semibold text-white min-h-16">{item.name}</h3>
                                            <div className="mt-2 flex justify-between items-center">
                                                <span className="text-sm text-gray-400">{moduleDescription(item?.module)}</span>
                                                <span className="text-sm text-green-500">
                                                    {(item.currentTime && item.duration) ? Math.round((item.currentTime / item.duration) * 100) : 0}%
                                                </span>
                                            </div>
                                            <div className="mt-2 h-2 bg-gray-600 rounded-full">
                                                <div className="h-full shim-green" style={{ width: `${(item.currentTime && item.duration) ? Math.round((item.currentTime / item.duration) * 100) : 0}%`, }}></div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </>
                    ) : (
                        <div className="flex flex-col items-center justify-center w-full h-64 bg-gray-800 rounded-lg">
                            <p className="text-white text-lg mb-4 p-4 text-center">{t("_CTFLIX._REQUIREDINTERMEDIATE")}</p>
                            <button className="text-md w-auto border-2 p-4 px-6 cursor-pointer rounded-xl bg-rose-500 text-white" onClick={() => goToPackages()}>{t("_DASHBOARD._UPGRADE")} </button>
                        </div>
                    )}
                    <h2 className="text-3xl font-semibold mt-12 mb-6">{t("_CTFLIX._ADVANCED")}</h2>
                    {packageUser >= 3 ? (
                        <>
                            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                                {filteredAdvancedList.map(item => (
                                    <div onClick={() => gotoPlay(item)} key={item.id} className="max-w-96 h-50 bg-gray-800 rounded-lg shadow-lg cursor-pointer opacity-50 hover:opacity-100 ">
                                        <img className="w-full h-40 object-cover" src={item?.image ? item?.image : Advanced} alt="Curso Advanced" />
                                        <div className="p-4">
                                            <h3 className="text-md font-semibold text-white min-h-16">{item.name}</h3>
                                            <div className="mt-2 flex justify-between items-center">
                                                <span className="text-sm text-gray-400">{moduleDescription(item?.module)}</span>
                                                <span className="text-sm text-green-500">
                                                    {(item.currentTime && item.duration) ? Math.round((item.currentTime / item.duration) * 100) : 0}%
                                                </span>
                                            </div>
                                            <div className="mt-2 h-2 bg-gray-600 rounded-full">
                                                <div className="h-full shim-green" style={{ width: `${(item.currentTime && item.duration) ? Math.round((item.currentTime / item.duration) * 100) : 0}%`, }}></div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </>
                    ) : (
                        <div className="flex flex-col items-center justify-center w-full h-64 bg-gray-800 rounded-lg">
                            <p className="text-white text-lg mb-4 p-4 text-center">{t("_CTFLIX._REQUIREDADVANCED")}</p>
                            <button className="text-md w-auto border-2 p-4 px-6 cursor-pointer rounded-xl bg-rose-500 text-white" onClick={() => goToPackages()}>{t("_DASHBOARD._UPGRADE")} </button>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default CTFLIX;
